import { Link } from "react-router-dom";
import teamMehul from "../assets/team-mehul.jpeg";
import teamRohan from "../assets/team-rohan.jpeg";
import "./About.css";

const values = [
  {
    icon: "🙏",
    title: "Devotion",
    desc: "Every action we take is rooted in devotion to Lord Ganesha and service to his devotees.",
  },
  {
    icon: "🤝",
    title: "Unity",
    desc: "We believe in the power of united mandal — one platform, one voice, one India.",
  },
  {
    icon: "💛",
    title: "Transparency",
    desc: "All donations and activities are openly reported and accounted for, earning community trust.",
  },
  {
    icon: "🌱",
    title: "Social Impact",
    desc: "Beyond celebrations, we drive real change through health camps, environment drives and welfare programmes.",
  },
];

const team = [
  { name: "Mehul Deshmukh", role: "Team Aarambh", photo: teamMehul },
  { name: "Rohan Deshmukh", role: "Team Aarambh", photo: teamRohan },
];

const milestones = [
  {
    year: "Before 2026",
    event:
      "Long before Aarambh existed, our founders and community quietly served — organising blood donation camps, food distribution and cleanliness drives without any banner, platform or public recognition.",
  },
  {
    year: "Early 2026",
    event:
      "Realised that this quiet service, spread across many mandal, needed one common platform to unite, coordinate and amplify its impact.",
  },
  {
    year: "2026",
    event:
      "Aarambh is officially launched — bringing Ganpati Mahotsav mandal of Valsad together on a single platform for transparent donations and coordinated social welfare.",
  },
  {
    year: "2026",
    event:
      "First mandal come on board; the Recognition & Rewards programme and Green & Social Initiatives guidelines are introduced to encourage eco-friendly, community-first celebrations.",
  },
  {
    year: "The Journey Ahead",
    event:
      "From this humble beginning, we're steadily growing — connecting more mandal, expanding social impact and building a transparent, trusted platform for Ganesh Mahotsav across Valsad district and beyond.",
  },
];

export default function About() {
  return (
    <div className="about-page">
      {/* Page Hero */}
      <div className="page-hero">
        <div className="container">
          <div className="badge">Our Story</div>
          <h1>About Aarambh</h1>
          <p>
            A charitable trust born from the devotion of Valsad's Ganpati community — uniting organisations, enabling
            giving and driving social change.
          </p>
        </div>
      </div>

      {/* Mission & Vision */}
      <section className="mission-section">
        <div className="container mission-grid">
          <div className="mission-card card">
            <div className="mission-icon">🎯</div>
            <h3>Our Mission</h3>
            <p>
              To connect every Ganpati Mahotsav Mandal in india on a single platform — making it easy to co-ordinate
              celebrations, receive donations and execute social welfare activities in the name of Lord Ganesha. We
              envision a Sarvajanik Ganesh Mahotsav where celebration goes beyond devotion—where communities come
              together with greater joy, take meaningful environmental action, coordinate social initiatives, and serve
              society in the name of Lord Ganesha
            </p>
          </div>
          <div className="mission-card card">
            <div className="mission-icon">🌟</div>
            <h3>Our Vision</h3>
            <p>
              India where every neighbourhood's Ganesh Utsav is celebrated with grandeur, every mandal is empowered with
              resources and every donation reaches those in need — transparently and joyfully.
            </p>
          </div>
          <div className="mission-card card">
            <div className="mission-icon">🏆</div>
            <h3>Our Goal</h3>
            <p>
              To become the most trusted charitable platform for Ganpati Mahotsav organisations in India — starting from
              Valsad and eventually connecting mandal across the state and beyond.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">What Drives Us</div>
            <h2>Our Core Values</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="values-grid">
            {values.map((v) => (
              <div key={v.title} className="value-card card">
                <div className="value-icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Milestones */}
      <section className="milestones-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Our Journey</div>
            <h2>Milestones</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="timeline">
            {milestones.map((m, i) => (
              <div key={i} className={`timeline-item${i % 2 === 0 ? " left" : " right"}`}>
                <div className="timeline-year">{m.year}</div>
                <div className="timeline-dot" />
                <div className="timeline-content card">
                  <p>{m.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">The People</div>
            <h2>Our Leadership Team</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>
          <div className="team-grid team-grid-featured">
            {team.map((m) => (
              <div key={m.name} className="team-card card">
                <div className="team-avatar team-avatar-photo">
                  <img src={m.photo} alt={m.name} />
                </div>
                <h3>{m.name}</h3>
                <p>{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="container" style={{ textAlign: "center" }}>
          <h2>Ready to Join Our Mission?</h2>
          <p>Register your mandal, make a donation or volunteer for social activities — every contribution matters.</p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", marginTop: "28px", flexWrap: "wrap" }}>
            <Link to="/register" className="btn-primary">
              Register Mandal
            </Link>
            <Link to="/donate" className="btn-outline">
              Make a Donation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
